import { Component } from '@angular/core';

@Component({
  selector: 'app-spirits-empty',
  standalone: true,
  imports: [],
  templateUrl: './spirits-empty.component.html',
  styleUrl: './spirits-empty.component.scss'
})
export class SpiritsEmptyComponent {

}
